import React, { useState } from 'react';
import { BarChart, Bar, PieChart, Pie, Cell, ResponsiveContainer, XAxis, YAxis, Tooltip, Legend } from 'recharts';
import { useReportContext } from './ReportContext';
// Add a mode prop to determine which button to show
export const RevenueReportView = ({
  mode = 'remove'
}) => {
  const [currentDate, setCurrentDate] = useState(new Date('2025-09-22'));
  const {
    saveReport
  } = useReportContext();
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [removeSuccess, setRemoveSuccess] = useState(false);
  const formatDate = date => {
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };
  const navigateDay = direction => {
    const newDate = new Date(currentDate);
    newDate.setDate(currentDate.getDate() + direction);
    setCurrentDate(newDate);
  };
  const handleSaveReport = () => {
    // Save the report
    saveReport({
      name: `Daily Revenue Report - ${formatDate(currentDate)}`,
      type: 'revenue',
      date: currentDate.toISOString()
    });
    // Show success message
    setSaveSuccess(true);
    setTimeout(() => setSaveSuccess(false), 3000);
  };
  const handleRemoveReport = () => {
    // Show success message for removal
    setRemoveSuccess(true);
    setTimeout(() => setRemoveSuccess(false), 3000);
  };
  // Data for the occupancy chart
  const occupancyData = [{
    name: 'Standard',
    occupied: 70,
    available: 10
  }, {
    name: 'Deluxe',
    occupied: 30,
    available: 10
  }, {
    name: 'Suite',
    occupied: 15,
    available: 5
  }, {
    name: 'Ocean View',
    occupied: 5,
    available: 5
  }];
  // Data for the revenue distribution pie chart
  const revenueDistributionData = [{
    name: 'Standard',
    value: 10500,
    percentage: 43,
    color: '#0088FE'
  }, {
    name: 'Deluxe',
    value: 7500,
    percentage: 30,
    color: '#00C49F'
  }, {
    name: 'Suite',
    value: 5250,
    percentage: 21,
    color: '#FFBB28'
  }, {
    name: 'Ocean View',
    value: 1350,
    percentage: 5,
    color: '#FF8042'
  }];
  // Data for the room type breakdown table
  const roomTypeData = [{
    type: 'Standard',
    roomsAvailable: 80,
    roomsSold: 70,
    revenue: 10500,
    adr: 150,
    occupancy: 87.5,
    revpar: 131.25
  }, {
    type: 'Deluxe',
    roomsAvailable: 40,
    roomsSold: 30,
    revenue: 7500,
    adr: 250,
    occupancy: 75,
    revpar: 187.5
  }, {
    type: 'Suite',
    roomsAvailable: 20,
    roomsSold: 15,
    revenue: 5250,
    adr: 350,
    occupancy: 75,
    revpar: 262.5
  }, {
    type: 'Ocean View',
    roomsAvailable: 10,
    roomsSold: 5,
    revenue: 1350,
    adr: 270,
    occupancy: 50,
    revpar: 135
  }];
  return <div className="p-6" data-id="element-318">
      <div className="mb-4 flex justify-between items-center" data-id="element-319">
        <div data-id="element-320">
          <h1 className="text-2xl font-bold text-gray-800" data-id="element-321">
            Daily Revenue Report
          </h1>
          <p className="text-sm text-gray-600" data-id="element-322">
            Tier 1 - Analytic | Daily snapshot of ADR, Occupancy %, RevPAR and
            room revenue
          </p>
        </div>
        <div className="flex items-center gap-3" data-id="element-323">
          {mode === 'save' && <>
              {saveSuccess && <span className="text-sm text-green-600 bg-green-50 py-1 px-3 rounded-full" data-id="element-324">
                  Report saved!
                </span>}
              <button onClick={handleSaveReport} className="flex items-center gap-1 bg-teal-500 hover:bg-teal-600 text-white px-4 py-2 rounded-lg transition-colors" data-id="element-325">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-326">
                  <path fillRule="evenodd" d="M3 17a1 1 0 001 1h12a1 1 0 001-1V7.414A1 1 0 0016.414 7L13 3.586A1 1 0 0012.586 3H4a1 1 0 00-1 1v13zm9.707-14.707l3 3A.997.997 0 0116 6V17H4V4h8.586a1 1 0 01.707.293z" clipRule="evenodd" data-id="element-327" />
                  <path fillRule="evenodd" d="M8 7a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1zm0 4a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z" clipRule="evenodd" data-id="element-328" />
                </svg>
                Save Report
              </button>
            </>}
          {mode === 'remove' && <>
              {removeSuccess && <span className="text-sm text-green-600 bg-green-50 py-1 px-3 rounded-full" data-id="element-329">
                  Report removed!
                </span>}
              <button onClick={handleRemoveReport} className="flex items-center gap-1 bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg transition-colors" data-id="element-330">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-331">
                  <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" data-id="element-332" />
                </svg>
                Remove
              </button>
            </>}
        </div>
      </div>
      {/* Date Navigation */}
      <div className="flex justify-between items-center mb-6 p-4 border rounded-lg bg-white shadow-sm" data-id="element-333">
        <button onClick={() => navigateDay(-1)} className="p-2 rounded-full hover:bg-gray-100" data-id="element-334">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-335">
            <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-336" />
          </svg>
        </button>
        <h2 className="text-lg font-medium" data-id="element-337">{formatDate(currentDate)}</h2>
        <button onClick={() => navigateDay(1)} className="p-2 rounded-full hover:bg-gray-100" data-id="element-338">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-339">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" data-id="element-340" />
          </svg>
        </button>
      </div>
      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-341">
        <div className="bg-blue-50 p-4 rounded-lg border border-blue-100" data-id="element-342">
          <h3 className="text-sm font-medium text-blue-800 mb-1" data-id="element-343">
            Rooms Available
          </h3>
          <p className="text-2xl font-bold text-blue-700" data-id="element-344">150</p>
          <p className="text-xs text-blue-600 mt-1" data-id="element-345">
            Total sellable rooms for the date
          </p>
        </div>
        <div className="bg-green-50 p-4 rounded-lg border border-green-100" data-id="element-346">
          <h3 className="text-sm font-medium text-green-800 mb-1" data-id="element-347">
            Rooms Sold
          </h3>
          <p className="text-2xl font-bold text-green-700" data-id="element-348">120</p>
          <p className="text-xs text-green-600 mt-1" data-id="element-349">
            Occupied rooms for the date
          </p>
        </div>
        <div className="bg-purple-50 p-4 rounded-lg border border-purple-100" data-id="element-350">
          <h3 className="text-sm font-medium text-purple-800 mb-1" data-id="element-351">
            Room Revenue
          </h3>
          <p className="text-2xl font-bold text-purple-700" data-id="element-352">$24,600.00</p>
          <p className="text-xs text-purple-600 mt-1" data-id="element-353">
            Total room revenue (gross)
          </p>
        </div>
      </div>
      {/* Key Metrics */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-354">
        <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-100" data-id="element-355">
          <h3 className="text-sm font-medium text-yellow-800 mb-1" data-id="element-356">ADR</h3>
          <p className="text-2xl font-bold text-yellow-700" data-id="element-357">$205.00</p>
          <p className="text-xs text-yellow-600 mt-1" data-id="element-358">
            Average Daily Rate = Room Revenue ÷ Rooms Sold
          </p>
        </div>
        <div className="bg-red-50 p-4 rounded-lg border border-red-100" data-id="element-359">
          <h3 className="text-sm font-medium text-red-800 mb-1" data-id="element-360">Occupancy %</h3>
          <p className="text-2xl font-bold text-red-700" data-id="element-361">80.0%</p>
          <p className="text-xs text-red-600 mt-1" data-id="element-362">
            Rooms Sold ÷ Rooms Available × 100
          </p>
        </div>
        <div className="bg-teal-50 p-4 rounded-lg border border-teal-100" data-id="element-363">
          <h3 className="text-sm font-medium text-teal-800 mb-1" data-id="element-364">RevPAR</h3>
          <p className="text-2xl font-bold text-teal-700" data-id="element-365">$164.00</p>
          <p className="text-xs text-teal-600 mt-1" data-id="element-366">
            Revenue per Available Room = Room Revenue ÷ Rooms Available
          </p>
        </div>
      </div>
      {/* Analytics Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6" data-id="element-367">
        <div className="bg-white p-4 rounded-lg border border-gray-200" data-id="element-368">
          <h3 className="text-lg font-medium text-gray-700 mb-4" data-id="element-369">
            Revenue Analytics
          </h3>
          {/* Room Type Occupancy Chart */}
          <div data-id="element-370">
            <h4 className="text-sm font-medium text-gray-600 mb-2" data-id="element-371">
              Room Type Occupancy
            </h4>
            <div className="h-64" data-id="element-372">
              <ResponsiveContainer width="100%" height="100%" data-id="element-373">
                <BarChart data={occupancyData} stackOffset="expand" layout="vertical" margin={{
                top: 10,
                right: 30,
                left: 20,
                bottom: 20
              }} data-id="element-374">
                  <XAxis type="number" domain={[0, 1]} tickFormatter={value => `${Math.round(value * 100)}%`} data-id="element-375" />
                  <YAxis type="category" dataKey="name" data-id="element-376" />
                  <Tooltip formatter={(value, name) => [`${Math.round(value * 100)}%`, name === 'occupied' ? 'Rooms Sold' : 'Rooms Available']} data-id="element-377" />
                  <Legend data-id="element-378" />
                  <Bar dataKey="occupied" stackId="a" fill="#8884d8" name="Rooms Sold" data-id="element-379" />
                  <Bar dataKey="available" stackId="a" fill="#82ca9d" name="Rooms Available" data-id="element-380" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
          {/* Revenue Distribution Chart */}
          <div className="mt-8" data-id="element-381">
            <h4 className="text-sm font-medium text-gray-600 mb-2" data-id="element-382">
              Revenue Distribution
            </h4>
            <div className="h-64 flex justify-center" data-id="element-383">
              <ResponsiveContainer width="100%" height="100%" data-id="element-384">
                <PieChart data-id="element-385">
                  <Pie data={revenueDistributionData} cx="50%" cy="50%" labelLine={false} outerRadius={80} fill="#8884d8" dataKey="value" label={({
                  name,
                  percentage
                }) => `${name} ${percentage}%`} data-id="element-386">
                    {revenueDistributionData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-387" />)}
                  </Pie>
                  <Tooltip formatter={value => [`$${value.toLocaleString()}`, 'Revenue']} data-id="element-388" />
                  <Legend data-id="element-389" />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
        {/* Room Type Breakdown */}
        <div className="bg-white p-4 rounded-lg border border-gray-200" data-id="element-390">
          <h3 className="text-lg font-medium text-gray-700 mb-4" data-id="element-391">
            Room Type Breakdown
          </h3>
          <p className="text-sm text-gray-600 mb-4" data-id="element-392">
            Performance by room category
          </p>
          <div className="overflow-x-auto" data-id="element-393">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-394">
              <thead data-id="element-395">
                <tr data-id="element-396">
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-397">
                    Room Type
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-398">
                    Rooms Available
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-399">
                    Rooms Sold
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-400">
                    Revenue
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-401">
                    ADR
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-402">
                    Occupancy %
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-403">
                    RevPAR
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-404">
                {roomTypeData.map((room, index) => <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} data-id="element-405">
                    <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-406">
                      {room.type}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-407">
                      {room.roomsAvailable}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-408">
                      {room.roomsSold}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-409">
                      ${room.revenue.toLocaleString()}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-410">
                      ${room.adr.toFixed(2)}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-411">
                      {room.occupancy.toFixed(1)}%
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-412">
                      ${room.revpar.toFixed(2)}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          <div className="mt-4 flex justify-between" data-id="element-413">
            <button className="p-2 text-gray-500 hover:text-gray-700" data-id="element-414">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-415">
                <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-416" />
              </svg>
            </button>
            <button className="p-2 text-gray-500 hover:text-gray-700" data-id="element-417">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-418">
                <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" data-id="element-419" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>;
};